import { PopupMessageBox } from "../../../../common/messageBox";
import { GameData } from "../../gamestate/gameData";
import {
  displayBonusGameInfosWindow,
  toggleBonusGameMode,
  replaceAllWithBonus,
} from "../../inGameFunction";
import { convertCreditsFromServerToClient } from "../../../../common/datastructures/Credits";
// import { getParameterByName } from "../../common/getParameters";
import {
  updateBalance,
  setAllowedInputs,
  jackpotWinCheck,
} from "../../../../common/functions/Functions_General";
import {
  enablePlay,
  enablePlayIfJackpotNotAvailable,
  stopAutoPlay,
} from "../../../../common/functions/Functions_GameBar";
import { replayMessageBox } from "./replayMessage";
import { JumpingCoins } from "../../../../common/gameLib/JumpingCoin/jumpingCoinMain";
import { updateEmulationWinBalance } from "../../../../common/gameLib/Replay/emulation/functionsEmulations";

export class BonusSpinMessageWindow {
  private parent: PIXI.Container;

  private messagetoDisplay: number;
  private bonusGameEndMessage: PopupMessageBox;
  private size: Array<number>;
  private activeGameData: GameData;

  private ReloadMessageBox: replayMessageBox;
  private newMessageBoxFrame: PIXI.Sprite;

  ///absorbtion effects
  private fx_absorbtion: Array<PIXI.Sprite>;
  private fx_absorbtionTween: Array<PIXI.tween.Tween>;
  private fx_absorbtionStar: Array<PIXI.Sprite>;
  private fx_absorbtionTweenStar: Array<PIXI.tween.Tween>;
  private absorbtionContainer: PIXI.Container;

  private newJumpCoin: JumpingCoins;

  constructor(
    parent: PIXI.Container,
    size: Array<number>,
    activeGameData: GameData
  ) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);

    this.messagetoDisplay = 1;
    this.bonusGameEndMessage;

    this.size = size;
    this.activeGameData = activeGameData;
    this.setup(parent);
    // /---create absorbtioneffect
    this.absorbtionContainer = new PIXI.Container();
    this.bonusGameEndMessage.getFramenull().addChild(this.absorbtionContainer);
    this.createAbsorbtion();
    this.playabsorbtionAnim(false);

    //--create new message box overlay
    this.ReloadMessageBox = new replayMessageBox(parent, size, activeGameData);


    this.newMessageBoxFrame = new PIXI.Sprite(
      PIXI.Texture.fromFrame("messageBox.png")
    );
    // this.newMessageBoxFrame.scale.set(3,.9);
    this.newMessageBoxFrame.y = 350 / 2-20;
    this.newMessageBoxFrame.x = 800 / 2;
    // [800, 350];
    this.newMessageBoxFrame.anchor.set(0.5);
    this.bonusGameEndMessage.getFramenull().addChild(this.newMessageBoxFrame);

    this.bonusGameEndMessage.setAlphaDefaultFrame(0);
    this.newJumpCoin = new JumpingCoins(
      this.activeGameData.coinsContainer,
      this.activeGameData.size,
      200
    );

		





    activeGameData.soundList.push(this.newJumpCoin.getCoinSound());
    this.newJumpCoin.setloop(false);
  }
  private playabsorbtionAnim = (bool: boolean): void => {
    for (let index = 0; index < this.fx_absorbtionTween.length; index++) {
      if (bool) {
        this.absorbtionContainer.alpha = 1;
        this.fx_absorbtionTween[index].reset();
        this.fx_absorbtionTween[0].start();
        this.fx_absorbtionTweenStar[index].reset();
        this.fx_absorbtionTweenStar[0].start();
      } else {
        this.absorbtionContainer.alpha = 0;
        this.fx_absorbtionTween[index].stop();
        this.fx_absorbtionTweenStar[index].stop();
      }
    }
  };
  private createAbsorbtion = (): void => {
    let maxFxCount = 3;
    this.fx_absorbtion = [];
    this.fx_absorbtionTween = [];

    for (let i = 0; i < maxFxCount; i++) {
      this.fx_absorbtion[i] = new PIXI.Sprite(
        PIXI.Texture.fromFrame("ZoomingFx.png")
      );
      // this.fx_absorbtion.tint=(0xffcc00)

      // [800, 350];
      this.fx_absorbtion[i].anchor.set(0.5);
      this.fx_absorbtion[i].position.set(800 / 2, 350 / 2);
      this.absorbtionContainer.addChild(this.fx_absorbtion[i]);
      this.fx_absorbtion[i].blendMode = PIXI.BLEND_MODES.ADD;
      this.fx_absorbtion[i].rotation = (Math.random() * 360 * Math.PI) / 180;
      this.fx_absorbtion[i].alpha = 0;
      this.fx_absorbtionTween[i] = PIXI.tweenManager.createTween(
        this.fx_absorbtion[i]
      );
      this.fx_absorbtionTween[i]
        .from({ scale: { x: 8, y:8 }, alpha: 0})
        .to({ scale: { x: 0, y: 0 }, alpha: .5});
      this.fx_absorbtionTween[i].time = 600;
      // this.fx_absorbtionTween[i].delay =  this.fx_absorbtionTween[i].time*(i*maxFxCount);
      // console.log(this.fx_absorbtionTween[i].delay)
      this.fx_absorbtionTween[i].easing = PIXI.tween.Easing.linear();
      this.fx_absorbtionTween[i].loop = false;
    }

    for (let i = 0; i < this.fx_absorbtionTween.length; i++) {
      if (i < this.fx_absorbtionTween.length - 1) {
        this.fx_absorbtionTween[i].on(
          "update",
          function(tween: PIXI.tween.Tween, elapsedTime: number) {
            if (elapsedTime > 0.5) {
              tween.start();
            }
          }.bind(this.fx_absorbtionTween[i], this.fx_absorbtionTween[i + 1])
        );
      }
      let lastAnim = this.fx_absorbtionTween.length - 1;
      this.fx_absorbtionTween[lastAnim].on(
        "update",
        function(tween: PIXI.tween.Tween, elapsedTime: number) {
          if (elapsedTime > 0.5) {
            tween.start();
          }
        }.bind(this.fx_absorbtionTween[lastAnim], this.fx_absorbtionTween[0])
      );
    }

    this.fx_absorbtionStar = [];
    this.fx_absorbtionTweenStar = [];

    for (let i = 0; i < maxFxCount; i++) {
      this.fx_absorbtionStar[i] = new PIXI.Sprite(
        PIXI.Texture.fromFrame("ZoomingFxStars.png")
      );

      // this.fx_absorbtionStar[i] = new PIXI.Sprite(
      //   PIXI.Texture.fromFrame("coins_000"+Math.floor(Math.random()*30+10)+".png")
      // );
      // this.fx_absorbtion.tint=(0xffcc00)
      this.fx_absorbtionStar[i].anchor.set(0.5);
      this.fx_absorbtionStar[i].position.set(800 / 2, 350 / 2);
      this.absorbtionContainer.addChild(this.fx_absorbtionStar[i]);
      this.fx_absorbtionStar[i].blendMode = PIXI.BLEND_MODES.ADD;
      this.fx_absorbtionStar[i].rotation =
        (Math.random() * 360 * Math.PI) / 180;
      this.fx_absorbtionStar[i].alpha = 0;
      this.fx_absorbtionTweenStar[i] = PIXI.tweenManager.createTween(
        this.fx_absorbtionStar[i]
      );
      this.fx_absorbtionTweenStar[i]
        .from({ scale: { x: 4, y: 4 }, alpha: 0 })
        .to({ scale: { x: 0, y: 0 }, alpha: 1});
      this.fx_absorbtionTweenStar[i].time = 2000;
      // this.fx_absorbtionTween[i].delay =  this.fx_absorbtionTween[i].time*(i*maxFxCount);
      // console.log(this.fx_absorbtionTweenStar[i].delay)
      this.fx_absorbtionTweenStar[i].easing = PIXI.tween.Easing.linear();
      this.fx_absorbtionTweenStar[i].loop = false;
    }

    for (let i = 0; i < this.fx_absorbtionTweenStar.length; i++) {
      if (i < this.fx_absorbtionTweenStar.length - 1) {
        this.fx_absorbtionTweenStar[i].on(
          "update",
          function(tween: PIXI.tween.Tween, elapsedTime: number) {
            if (elapsedTime > 0.5) {
              tween.start();
            }
          }.bind(
            this.fx_absorbtionTweenStar[i],
            this.fx_absorbtionTweenStar[i + 1]
          )
        );
      }
      let lastAnim = this.fx_absorbtionTweenStar.length - 1;
      this.fx_absorbtionTweenStar[lastAnim].on(
        "update",
        function(tween: PIXI.tween.Tween, elapsedTime: number) {
          if (elapsedTime > 0.5) {
            tween.start();
          }
        }.bind(
          this.fx_absorbtionTweenStar[lastAnim],
          this.fx_absorbtionTweenStar[0]
        )
      );
    }
  };

  public getReloadMessageBoxOpen = (): Function => {
    return this.ReloadMessageBox.getDisplayMessageIn;
  };

  public getReloadMessageBox = (): replayMessageBox => {
    return this.ReloadMessageBox;
  };

  private setup = (_parent: PIXI.Container): void => {
    this.parent.alpha = 0;
    // this.inTween.pingpong=true;

    this.bonusGameEndMessage = new PopupMessageBox(
      1,
      this.size,
      this.activeGameData
    );
    this.bonusGameEndMessage.setHeadText(
      this.activeGameData.gameTextGeneral.congrats
    );
    this.bonusGameEndMessage.setBodyText("!");
    // this.bonusGameEndMessage.setChildOf(this.parent);
    this.bonusGameEndMessage.setLabel(
      0,
      this.activeGameData.gameTextGeneral.continue
    );
    this.bonusGameEndMessage.setButtons(0, this.close.bind(this));
    // this.close()  ;
    this.bonusGameEndMessage.setMessageBoxPosY(380);
  };

  public close = (): void => {
    this.newJumpCoin.stop();
    this.activeGameData.mainGame.getPostExpandAnim().clearAll();
    this.playabsorbtionAnim(false);
    this.activeGameData.environment.checkBonusGameMusic();
    this.activeGameData.mainGame.setWinlineHidden();
    this.activeGameData.newWinAnimation.stop();
    this.activeGameData.freeSpinMode.setMessageDisplay();
    this.parent.alpha = 0;

    this.bonusGameEndMessage.setMessageBoxVisibile(false);

    this.activeGameData.resetAllBtns(this.activeGameData);
    enablePlayIfJackpotNotAvailable(this.activeGameData);
    this.activeGameData.isBonusMessageVisible = false;

    if (this.messagetoDisplay == 1) {
      // let test=this.activeGameData.GameContext().usedInputAction==this.activeGameData.API_handler.getSe();
      // console.log((this.activeGameData.betResponse.gameContext.contextData).usedInputAction, this.activeGameData.API_handler.getServerActionBonusSpin())
      if (this.activeGameData.GameContext().gameRoundBalance.bonusSpins == 0) {
        updateBalance(this.activeGameData);
      }

      displayBonusGameInfosWindow(false, this.activeGameData);
         //update emulation balance if game round is ended
    updateEmulationWinBalance(this.activeGameData);
    }

    if (this.messagetoDisplay == 2) {
      replaceAllWithBonus(this.activeGameData, true);

      this.activeGameData.bonusGameMode = true;
      this.activeGameData.bonusGameModeStarted = true;
    } else {
      this.activeGameData.bonusGameMode = false;
      this.activeGameData.bonusGameModeStarted = false;
      replaceAllWithBonus(this.activeGameData, false);
      // console.log("EXIT BONUS GAME")
      this.activeGameData.mainGame.setBonusLeftVisible(false);
      this.activeGameData.environment.isBonusGame(false); //exit bonus game
    }

    toggleBonusGameMode(this.activeGameData);

    if (this.activeGameData.GameContext().bonus)
      this.activeGameData.mainGame.setWinlineHidden();
    setAllowedInputs(this.activeGameData);
    if (
      this.activeGameData.GameContext().bonus &&
      this.activeGameData.replayMode
    ) {
      // console.log("increment2")
      this.activeGameData.replay.incrementIndex();
      // console.log("INCREASEssssssss")
    }
    this.activeGameData.mainGame.clearBonusSymbolsBackground();


    //--open jackpot game
    jackpotWinCheck(this.activeGameData);
  };
  public resetMessageIndex=():void=>
  {
    this.messagetoDisplay=1;
  }
  public setRecoveryText = (): void => {
    this.bonusGameEndMessage.setBodyText(
      this.activeGameData.gameTextGeneral.gameRecovered + ""
    );
    this.bonusGameEndMessage.setHeadText(" ");
    this.newMessageBoxFrame.alpha = 0;
    //----
  };

  public setNewText = (head: string, body: string): void => {
    this.bonusGameEndMessage.setHeadText(head);
    this.bonusGameEndMessage.setBodyText(body);
    this.newMessageBoxFrame.alpha = 0;
  };

 private closeActiveSelectBOnusSymbolAnimation=():void=>
  {
    this.activeGameData.mainGame.forceCloseBonusSymbolSelectionScreen();
  }
  public displayMessageIn = (): void => {
    this.closeActiveSelectBOnusSymbolAnimation();
    //--disble for  bonus buy
    this.activeGameData.BuyBonus.enableBuyBonusIfAllowed(false);

    this.playabsorbtionAnim(true);
    stopAutoPlay(this.activeGameData);
    this.activeGameData.playable = false;
    // if (this.messagetoDisplay === 1) {

    enablePlay(false, this.activeGameData);
    this.activeGameData.isBonusMessageVisible = true;
    this.bonusGameEndMessage.setBodyText(
      this.activeGameData.gameTextGeneral.msgFS3 +
        " " +
        this.activeGameData.GameContext().gameRoundBalance.bonusSpins +
        " " +
        this.activeGameData.gameText.firespins +
        "!"
    );
    this.parent.alpha = 1;
    this.bonusGameEndMessage.setMessageBoxVisibile(true, 0); //make it interactive
    this.messagetoDisplay = 2;

    this.activeGameData.mainGame.setBonusLeft(
      this.activeGameData.GameContext().gameRoundBalance.bonusSpins
    );
    this.newMessageBoxFrame.alpha = 1;
	
  };


  public displayMessageOut = (): void => {

    //--disble for  bonus buy
    this.activeGameData.BuyBonus.enableBuyBonusIfAllowed(false);
    this.playabsorbtionAnim(true);
    stopAutoPlay(this.activeGameData);
    this.newMessageBoxFrame.alpha = 1;

    // console.log("openEXIT")
    this.activeGameData.disableAllBtns(this.activeGameData);
    enablePlay(false, this.activeGameData);
    this.activeGameData.isBonusMessageVisible = true;

    this.bonusGameEndMessage.setBodyText(
      this.activeGameData.gameTextGeneral.totalWin + " :"
    );
    this.bonusGameEndMessage.setBodyText2(
      convertCreditsFromServerToClient(
        this.activeGameData.GameContext().gameRoundBalance.credits.amount
      ).toFixed(2) +
        "  " +
        this.activeGameData.currency +
        " !"
    );

    this.parent.alpha = 1;
    this.bonusGameEndMessage.setMessageBoxVisibile(true, 0);
    this.messagetoDisplay = 1;

    // this.activeGameData.jumpCoin.startJump();
    this.newJumpCoin.startJump();

    //

    this.activeGameData.sound_bellRing.stop();
    this.activeGameData.sound_epicBonusEnd.stop()
    this.activeGameData.sound_bellRing.play("sound");
    this.activeGameData.sound_epicBonusEnd.play("sound");

    // this.activeGameData.environment.checkBonusGameMusic();
    // this.chechBonusMusic()
    this.activeGameData.replay.replayCollectWinCheck();
  };

  // }

  public getAlpha() {
    // let i = this.parent.alpha ? true : false;
    return this.parent.alpha;
  }
}
